export const FETCH_BATCHES_REQUEST = 'FETCH_BATCHES_REQUEST';
export const FETCH_BATCH_METADATA_REQUEST = 'FETCH_BATCH_METADATA_REQUEST';
export const DOWNLOAD_BATCHES_DATA_REQUEST = 'DOWNLOAD_BATCHES_DATA_REQUEST';
export const GET_BATCH_DETAILS = 'GET_BATCH_DETAILS';
export const GET_PRODUCT_META_LIST = 'GET_PRODUCT_META_LIST';
export const GET_SITE_META_LIST = 'GET_SITE_META_LIST';
export const GET_MFG_META_LIST = 'GET_MFG_META_LIST';
export const CLEAR_ROW = 'CLEAR_ROW';
export const All_BATCHES = 'All_BATCHES';
export const GET_ALL_BATCHES = 'GET_ALL_BATCHES';
export const GET_BATCHES_STATUS = 'GET_BATCHES_STATUS';
export const FETCH_PARTIAL_BATCHES_REQUEST = 'FETCH_PARTIAL_BATCHES_REQUEST';
